export { default } from "./FollowStoreButton";
export { default as FollowStoreButton } from "./FollowStoreButton";



// WEBPACK FOOTER //
// ./src/components/FollowStoreButton/index.ts